export const LOGIN_URL = 'https://translation-platform.site:443';
// export const API_URL = 'https://edu-trans.ewha.ac.kr/';
export const DOWNLOAD_URL = 'https://edu-trans.ewha.ac.kr/'
export const API_URL = `${process.env.REACT_APP_API_URL}`;
